import API from "../../../store/api";
import { getAllUsers } from './getAllUsers';
import { setNotifications } from '../../../store/actions/notificationActions';
import { clearMessage, setMessage } from '../../../store/actions/dialogActions';
import { clearUsers } from '../../../store/actions/usersActions';
import { authLogout } from '../../../store/actions/authActions';

export const createUser = (userData, bearerAuth, formFunction) => {
  return async dispatch => {

    dispatch(setMessage({ type: 'LOAD' }))

    API.post(`/api/portal/users`)
      .set('Authorization', `Bearer ${bearerAuth}`)
      .send(userData)
      .ok(res => res.status === 201 || res.status === 401)
      .then((response) => {
        if (response.status === 201) {
          dispatch(clearMessage)
          dispatch(getAllUsers(bearerAuth))
          dispatch(setNotifications({
            type: 'success',
            message: 'Successfully created.'
          }))
          formFunction()
        } else if (response.status === 401) {
          dispatch(clearUsers);
          dispatch(authLogout);
        }
      }).catch((error) => {
        let message = 'An error has occurred';
        if (error.message) {
          message = error.message;
        }
        if (error.response && error.response.body) {
          if (error.response.body.messages) {
            message = error.response.body.messages.toString();
            if (message.includes(',')) { //Password error, make it more presentable
              let messageArray = message.split(',');
              message = <>{messageArray.map((val) => <div>{val}</div>)}</>
            }
          } 
        }
        dispatch(setMessage({
          title: 'Create User Failed',
          message: message,
          type: 'ERR',
        }))
      })
  }
}